import { Component, EventEmitter, Input, Output } from '@angular/core';
/* eslint-disable */

@Component({
    selector: 'nio-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.scss'],
    standalone: false
})
export class PaginatorComponent {
  @Input() pageSize;
  @Input() activePage;
  @Input() pages;
  @Output() pageChanged: EventEmitter<number> = new EventEmitter<number>();

  constructor() {}

  jumpToPage(pageIdx) {
    this.pageChanged.emit(pageIdx);
  }
}
